export const SeasonTicket = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28.9999 25H3V16.5V13V7H28.9999V13C27.9999 13.0156 25.9999 13.6373 25.9999 16C25.9999 18.3627 27.9999 18.9845 28.9999 19V25Z" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M20 7V11" stroke="currentColor" stroke-width="2"/>
<path d="M20 13V19" stroke="currentColor" stroke-width="2"/>
<path d="M20 21V25" stroke="currentColor" stroke-width="2"/>
<path d="M6 12H16" stroke="currentColor" stroke-width="2"/>
<path d="M6 20H12" stroke="currentColor" stroke-width="2"/>
<path d="M6 16H14" stroke="currentColor" stroke-width="2"/>
</svg>`;
